(function () {
  const container = document.getElementById('pdf-main-container');
  const loader = document.getElementById('pdf-loader');
  if (!container) return;

  const url = container.getAttribute('data-pdf-url');
  const workerSrc = container.getAttribute('data-worker-src');

  pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;

  const overlayLinks = [
    { targetPos: 20.4,  style: { top: '10.7%',  left: '10%', width: '80%', height: '0.7%' } },
    { targetPos: 35.0, style: { top: '11.6%',  left: '10%', width: '80%', height: '0.7%' } },
    { targetPos: 50.0, style: { top: '12.46%', left: '10%', width: '80%', height: '0.7%' } },
    { targetPos: 65.0, style: { top: '13.34%', left: '10%', width: '80%', height: '0.7%' } },
    { targetPos: 85.0, style: { top: '14.2%',  left: '10%', width: '80%', height: '0.7%' } }
  ];

  async function renderPDF() {
    try {
      const loadingTask = pdfjsLib.getDocument(url);
      const pdf = await loadingTask.promise;
      if(loader) loader.remove();

      const page = await pdf.getPage(1);
      
      const wrapper = document.createElement('div');
      wrapper.className = 'pdf-page-wrapper';
      wrapper.id = 'pdf-single-page-root';
      wrapper.style.position = 'relative';

      const canvas = document.createElement('canvas');
      canvas.className = 'pdf-page-canvas';
      
      wrapper.appendChild(canvas);
      container.appendChild(wrapper);

      overlayLinks.forEach(linkCfg => {
        const link = document.createElement('a');
        link.className = 'pdf-overlay-link'; // CSSでデザインするためのクラス
        Object.assign(link.style, linkCfg.style);
        link.style.position = 'absolute';
        link.style.display = 'block';
        link.style.zIndex = '999';
        link.style.cursor = 'pointer';

        link.addEventListener('click', (e) => {
          e.preventDefault();
          const fullHeight = wrapper.offsetHeight;
          const scrollToY = (fullHeight * (linkCfg.targetPos / 100)) + wrapper.offsetTop;
          window.scrollTo({ top: scrollToY, behavior: 'smooth' });
        });
        wrapper.appendChild(link);
      });

      const viewport = page.getViewport({ scale: 2.0 });
      const context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      await page.render({ canvasContext: context, viewport: viewport }).promise;

    } catch (e) {
      console.error(e);
    }
  }
  renderPDF();
})();

window.addEventListener('scroll', () => {
  const header = document.getElementById('pdf-sticky-header');
  const title = document.getElementById('current-chapter-title');
  const container = document.getElementById('pdf-main-container');
  if (!header || !container) return;

  const rect = container.getBoundingClientRect();
  const containerTop = rect.top + window.pageYOffset;
  const containerHeight = container.offsetHeight;
  const scrollY = window.pageYOffset;

  if (scrollY > containerTop + 50) {
    header.style.display = 'block';
  } else {
    header.style.display = 'none';
  }

  const relativeScroll = scrollY - containerTop;
  const progress = (relativeScroll / containerHeight) * 100;

  if (progress < 15) {
    title.textContent = 'おいしいお茶の淹れ方';
  } else if (progress < 30) {
    title.textContent = '1. 抹茶の点て方';
  } else if (progress < 46) {
    title.textContent = '2. 抹茶ラテ';
  } else if (progress < 62) {
    title.textContent = '3. 抹茶アイスクリーム';
  } else if (progress < 80) {
    title.textContent = '4. 抹茶スイーツ';
  } else {
    title.textContent = '5. 抹茶スムージー';
  }
});